import { Instance } from "mobx-state-tree";
import React from "react";
import { MultiSelectResponseV1Model } from "../../models/RespondentSubmittedResponseModels/MultiSelectResponseV1Model";
import { Stack, Typography } from "@mui/material";
import { S1TypographyLabel } from "./S1TypographyLabel";
import { TFunction } from "i18next";
import {
  FoundationColorTokens,
  Typography as LeoTypography,
  Spacing,
} from "@surya-digital/leo-reactjs-material-ui";
import { B1TypographyLabel } from "./B1TypographyLabel";
import { observer } from "mobx-react";

interface MultiSelectResponseProps {
  question: string | null;
  multiSelectResponse: Instance<typeof MultiSelectResponseV1Model>;
  t: TFunction;
  tokens: FoundationColorTokens<string>;
  typography: LeoTypography;
  spacing: Spacing;
}

export const MultiSelectResponse = observer(
  ({
    question,
    multiSelectResponse,
    t,
    tokens,
    typography,
    spacing,
  }: MultiSelectResponseProps): React.ReactElement => {
    const formattedResponse = multiSelectResponse.multiSelectResponse
      .split(",")
      .join(",\n");
    return (
      <Stack>
        {question && (
          <S1TypographyLabel
            text={t("projects.respondentResponseDialog.questionPrefix", {
              question,
            })}
            tokens={tokens}
            typography={typography}
          />
        )}
        <Stack direction="row" gap={spacing.spaceXXS}>
          <B1TypographyLabel
            text={t("projects.respondentResponseDialog.answerPrefix", {
              response: "",
            })}
            tokens={tokens}
            typography={typography}
          />
          <Typography
            {...typography.b1}
            color={tokens.label}
            style={{ whiteSpace: "pre-line" }}
          >
            {formattedResponse}
          </Typography>
        </Stack>
      </Stack>
    );
  },
);
